import { selectCurrentHotelId } from 'accessors'
import {
  PrimaryRegularButton,
  SecondaryRegularButton
} from 'components/ReusableComponents/Button/RegularButtons'
import CloseIcon from 'components/ReusableComponents/CloseIcon'
import Dialog from 'components/ReusableComponents/Dialog'
import LoadingIndicator from 'components/ReusableComponents/LoadingIndicator'
import RateCodeDropdown from 'features/Messaging/GuestInfoSidebar/AvailabilitySearchForm/AvailabilityDialog/FilterableDropdown'
import OccupancyBar from 'features/Messaging/GuestInfoSidebar/AvailabilitySearchForm/AvailabilityDialog/OccupancyBar'
import FeaturedRoom from 'features/Savibook/FeaturedRoom'
import SavibookRoomRow from 'features/Savibook/RoomRow'
import useCopyText from 'hooks/useCopyText'
import { BEs, BEsUsingPromoCode } from 'main/hotelBrandsAndChains'
import moment from 'moment'
import { useCallback, useEffect, useRef, useState } from 'react'
import DatePicker from 'react-datepicker'
import { useSelector } from 'react-redux'
import { useToasts } from 'react-toast-notifications'
import bookingsApi from 'services/api/bookings'
import chatApi from 'services/api/chat'
import subsidiariesApi from 'services/api/subsidiaries'

import styles from './AvailabilityDialog.module.scss'

// function waitFor(millSeconds) {
//   return new Promise(resolve => {
//     setTimeout(() => {
//       resolve()
//     }, millSeconds)
//   })
// }

// async function retryPromiseWithDelay(promisefn, args, retries = 3, interval = 600) {
//   try {
//     const res = await promisefn(args)
//     return res
//   } catch (e) {
//     if (retries === 1) {
//       return Promise.reject(e)
//     }
//     await waitFor(interval)
//     return retryPromiseWithDelay(promisefn, args, retries - 1, interval)
//   }
// }

const AvailabilityDialog = ({ chatId, onClose, subscriberId, lastShortlink }) => {
  // const [isLoadingOTAData, setIsLoadingOTAData] = useState(true)
  // const [isErredOTAData, setIsErredOTAData] = useState()

  const [beDialogClosedManually, setBeDialogClosedManually] = useState(false)

  // const [otaData, setOtaData] = useState()

  const { addToast } = useToasts()

  const windowWidth = 500
  const windowHeight = Math.min(window.innerHeight * 0.8, 800) - 50

  const beColRef = useRef()

  const isGdsBookingAvailable = useSelector(s => s.hotelDetails.isGdsBookingAvailable)

  const { bookingEngine } = useSelector(s => s.hotelDetails)

  const usePromo = BEsUsingPromoCode.includes(bookingEngine)

  const [checkInDate, setCheckInDate] = useState(moment().toDate())
  const [checkOutDate, setCheckOutDate] = useState(moment().add(1, 'day').toDate())

  const [rateCodes, setRateCodes] = useState([])
  const [promoCodes, setPromoCodes] = useState([])
  const [selectedPromoCode, setSelectedPromoCode] = useState(null)

  const [selectedRateCode, setSelectedRateCode] = useState(null)

  const subsidiaryId = useSelector(selectCurrentHotelId)

  const [beLink, setBeLink] = useState('')

  function updateResults() {
    updateBeLink()
    updateGdsResults()
    //updateOtaPrices()
  }

  const updateGdsResults = useCallback(() => {
    if (isGdsBookingAvailable) {
      setIsLoadingAvailability(true)

      bookingsApi
        .availability({
          checkIn: moment(checkInDate).format('YYYY-MM-DD'),
          checkOut: moment(checkOutDate).format('YYYY-MM-DD'),
          subscriberId
        })
        .then(res => {
          setAvailability(res)
          setIsAvailabilityErred(false)
        })
        .catch(() => {
          setIsAvailabilityErred(true)
        })
        .finally(() => {
          setIsLoadingAvailability(false)
        })
    }
  }, [checkInDate, checkOutDate, isGdsBookingAvailable, subscriberId])

  const updateBeLink = useCallback(() => {
    const choiceSafeRateCode =
      bookingEngine === BEs.choicehotels && selectedRateCode === 'BAR'
        ? 'RACK'
        : selectedRateCode

    if (chatId) {
      fetch(
        `https://api-core.swaypay.net/api/bookingengine/link?SubsidiaryId=${subsidiaryId}${
          choiceSafeRateCode || selectedPromoCode
            ? `&PromotionCode=${choiceSafeRateCode || selectedPromoCode}`
            : ''
        }&CheckIn=${moment(checkInDate).format('YYYY-MM-DD')}&CheckOut=${moment(
          checkOutDate
        ).format('YYYY-MM-DD')}`
      )
        .then(res => res.json())
        .then(res => {
          if (!res.isSuccess) throw new Error(res.message)
          setBeLink(res.result.url)
        })
        .catch(() => {
          addToast(`Couldn't get booking engine link`, {
            appearance: 'error',
            autoDismiss: true
          })
        })
    }
  }, [
    addToast,
    bookingEngine,
    chatId,
    checkInDate,
    checkOutDate,
    selectedPromoCode,
    selectedRateCode,
    subsidiaryId
  ])

  // const updateOtaPrices = useCallback(() => {
  //   setIsLoadingOTAData(true)
  //   setIsErredOTAData(false)

  //   try {
  //     retryPromiseWithDelay(bookingsApi.otaPrices, {
  //       checkIn: moment(checkInDate).format('YYYY-MM-DD'),
  //       checkOut: moment(checkOutDate).format('YYYY-MM-DD')
  //     })
  //       .then(data => {
  //         setOtaData(data)
  //         setIsErredOTAData(false)
  //       })
  //       .catch(err => {
  //         setIsErredOTAData(true)
  //         addToast(`Something went wrong: ${err.toString()}`, { appearance: 'error' })
  //       })
  //       .finally(() => {
  //         setIsLoadingOTAData(false)
  //       })
  //   } catch (e) {
  //     console.log(e)
  //   }
  // }, [checkInDate, checkOutDate, addToast])

  useEffect(() => {
    if (moment(checkOutDate).isBefore(moment(checkInDate))) {
      setCheckOutDate(moment(checkInDate).add(1, 'day').toDate())
    }
  }, [checkInDate, checkOutDate])

  useEffect(() => {
    subsidiariesApi.promoCodes.get().then(promoCodes => {
      setPromoCodes(
        promoCodes.reduce(
          (acc, item) => ({ ...acc, [item.promotionCode]: item.promotionCode }),
          {}
        )
      )
    })
  }, [])

  useEffect(() => {
    subsidiariesApi.rateCodes.get().then(res => {
      const rateCodes = Object.values(res)
        .flat()
        .map(r => r.code)
        .reduce((prev, curr) => ({ ...prev, [curr]: curr }), {})

      setRateCodes(rateCodes)
    })
  }, [bookingEngine])

  var windowTop =
    window.screenTop +
    window.outerHeight -
    window.innerHeight +
    (window.innerHeight - windowHeight) / 2

  const [isLoadingAvailability, setIsLoadingAvailability] = useState(true)
  const [isAvailabilityErred, setIsAvailabilityErred] = useState(false)
  const [availability, setAvailability] = useState()

  const copy = useCopyText()

  const beName = beLink
    ? beLink?.match(/^(?:https?:\/\/)?(?:[^@\/\n]+@)?(?:www\.)?([^:\/?\n]+)/)[1]
    : 'Booking engine'

  useEffect(() => {
    if (beLink) {
      console.warn('opening popup with', beLink)
      const bePopup = window.open(
        beLink,
        '_blank',
        'toolbar=yes,scrollbars=yes,resizable=yes,top=' +
          (window.screenTop +
            window.outerHeight -
            window.innerHeight +
            beColRef.current.offsetTop +
            90 +
            0) +
          ',left=' +
          (beColRef.current.offsetLeft + window.screenLeft) +
          `,width=${windowWidth},height=${windowHeight}`
      )

      if (bePopup) {
        bePopup.onunload = () => {
          setBeDialogClosedManually(true)
        }
      }

      return () => {
        bePopup?.close()
      }
    }
  }, [beLink, windowTop, windowWidth, windowHeight])

  useEffect(() => {
    if (checkInDate && checkOutDate && !beLink) {
      updateBeLink()
      updateGdsResults()
      //updateOtaPrices()
    }
  }, [checkInDate, checkOutDate, beLink, updateBeLink, updateGdsResults])

  function handleSavibookMessage(bookingCode) {
    chatApi
      .generateSavibookLink({
        chatId,
        checkIn: moment(checkInDate).format('YYYY-MM-DD'),
        overrideUrl: `${lastShortlink}/book?checkInDate=${moment(checkInDate).format(
          'YYYY-MM-DD'
        )}&checkOutDate=${moment(checkOutDate).format(
          'YYYY-MM-DD'
        )}&roomCode=${bookingCode}&guestCount=1`
      })
      .then(savibookLink => {
        copy(savibookLink)
      })
      .catch(err => {
        addToast(`Something went wrong: ${err.toString()}`, { appearance: 'error' })
      })
  }

  function copyBESavibookLink(chatId, checkInDate, overrideUrl) {
    chatApi
      .generateSavibookLink({
        chatId,
        checkIn: moment(checkInDate).format('YYYY-MM-DD'),
        overrideUrl
      })
      .then(savibookLink => {
        copy(savibookLink)
      })
      .catch(err => {
        addToast(`Something went wrong: ${err.toString()}`, { appearance: 'error' })
      })
  }

  return (
    <Dialog verticalPadding={0}>
      <div className={styles.wrapper}>
        <div className={styles.topBar}>
          <div className={styles.topBarInner}>
            <div className={styles.searchForm}>
              <DatePicker
                dateFormat="MMM dd"
                className={styles.datepickerInput}
                selected={checkInDate}
                onChange={setCheckInDate}
                minDate={moment().toDate()}
                wrapperClassName={styles.datepickerWrapper}
              />
              <span className={styles.dateseperator}>-</span>
              <DatePicker
                dateFormat="MMM dd"
                className={styles.datepickerInput}
                selected={checkOutDate}
                onChange={setCheckOutDate}
                minDate={checkInDate}
                wrapperClassName={styles.datepickerWrapper}
              />
              <span style={{ opacity: 0.4 }} className={styles.dateseperator}>
                •
              </span>
              {usePromo ? (
                <>
                  <label className={styles.promoCodeHolder}>
                    <p className={styles.promoCodeLabel}>Promo code</p>
                    <input
                      list="promo-codes"
                      placeholder="Add a promo code"
                      onChange={e => setSelectedPromoCode(e.target.value)}
                      value={selectedPromoCode}
                      className={styles.promoCodeInput}
                    />
                    <datalist id="promo-codes">
                      {Object.keys(promoCodes).map(promoCode => (
                        <option key={promoCode} value={promoCode} />
                      ))}
                    </datalist>
                  </label>
                </>
              ) : (
                <RateCodeDropdown
                  className={styles.dropdown}
                  label="Rate code"
                  options={rateCodes}
                  value={selectedRateCode}
                  onChangeValue={setSelectedRateCode}
                  isSortedAlphabetically={false}
                />
              )}
              <div className={styles.buttons}>
                <PrimaryRegularButton onClick={() => updateResults()}>
                  Update results
                </PrimaryRegularButton>
                {/* <SecondaryRegularButton // TODO: move this 
                style={{ background: 'white' }}
                onClick={() => copyBESavibookLink(chatId, checkInDate, beLink)}
              >
                Copy link
              </SecondaryRegularButton> */}
              </div>
            </div>
            <OccupancyBar />
          </div>
        </div>
        <div className={styles.container}>
          <button className={styles.closeButton} onClick={onClose}>
            <CloseIcon />
          </button>
          {isGdsBookingAvailable && (
            <div className={styles.col}>
              <p className={styles.colTitle}>Savibook GDS</p>
              <div className={styles.colInner}>
                {!isGdsBookingAvailable ? (
                  <div className={styles.availabilityResults}>
                    <p className={styles.errorText}>
                      GDS availability is not enabled for this hotel.
                    </p>
                  </div>
                ) : (
                  <div className={styles.availabilityResults}>
                    {isLoadingAvailability && <LoadingIndicator inline />}
                    {!isLoadingAvailability && !availability?.rooms && (
                      <p className={styles.errorText}>
                        Couldn't get availability for selected dates
                      </p>
                    )}
                    {!isLoadingAvailability &&
                      !isAvailabilityErred &&
                      availability &&
                      availability?.rooms && (
                        <div className={styles.savibookHolder}>
                          <p className={styles.otherRoomsTitle}>Best option</p>
                          <FeaturedRoom
                            rooms={availability.rooms}
                            previousBooking={availability.previousBooking}
                            onSelectRoom={room =>
                              handleSavibookMessage(room.roomBookingCode)
                            }
                          />
                          <div className={styles.roomsHolder}>
                            <p className={styles.otherRoomsTitle}>All rooms</p>
                            {availability?.rooms ? (
                              availability.rooms.map(room => (
                                <SavibookRoomRow
                                  name={room.roomName}
                                  description={room.description}
                                  nightlyPrice={room.availablePrice.nightlyRateBase}
                                  key={room.reservationCode}
                                  isCheapest={room.isCheapest}
                                  isPostPay={
                                    room.availablePrice.ratePayment === 'PostPay'
                                  }
                                  onSelectRoom={() =>
                                    handleSavibookMessage(room.roomBookingCode)
                                  }
                                />
                              ))
                            ) : (
                              <p>Couldn't get availability for selected dates</p>
                            )}
                          </div>
                        </div>
                      )}
                  </div>
                )}
              </div>
            </div>
          )}
          {/* <div className={styles.col}>
            <p className={styles.colTitle}>OTA prices</p>
            <div className={styles.colInner}>
              <div className={styles.otaComparision}>
                {isLoadingOTAData && (
                  <LoadingIndicator inline longWaitingTreshold={10000} />
                )}
                {isErredOTAData && <p>Something went wrong while getting rates</p>}
                {!isLoadingOTAData && !isErredOTAData && (
                  <div className={styles.otaComparisionHolder}>
                    {!otaData && (
                      <p className={styles.errorText}>
                        Couldn't get OTA rates for selected dates
                      </p>
                    )}
                    {otaData && (
                      <p className={styles.otaDisclaimer}>Prices are without tax</p>
                    )}
                    {otaData &&
                      otaData.rates.map(rate => (
                        <div
                          key={rate.code}
                          style={{ display: 'flex', fontSize: 16, lineHeight: 2.4 }}
                        >
                          <span>{rate.name}</span>
                          <span style={{ marginLeft: 'auto', fontWeight: 500 }}>
                            {formatPrice(rate.rate)}
                          </span>
                        </div>
                      ))}
                  </div>
                )}
              </div>
            </div>
          </div> */}
          <div className={styles.col} ref={beColRef}>
            <p className={styles.colTitle}>
              {beName}
              <SecondaryRegularButton
                className={styles.offerLinkButton}
                onClick={() => copyBESavibookLink(chatId, checkInDate, beLink)}
              >
                Copy offer link
              </SecondaryRegularButton>
            </p>
            <div className={styles.colInner}>
              <div className={styles.beDialogCol}>
                {beDialogClosedManually && (
                  <SecondaryRegularButton
                    onClick={() =>
                      window.open(
                        beLink,
                        '_blank',
                        'toolbar=yes,scrollbars=yes,resizable=yes,top=' +
                          (window.screenTop +
                            window.outerHeight -
                            window.innerHeight +
                            beColRef.current.offsetTop +
                            90 +
                            0) +
                          ',left=' +
                          (beColRef.current.offsetLeft + window.screenLeft) +
                          `,width=${windowWidth},height=${windowHeight}`
                      )
                    }
                  >
                    Open {beName} pop-up
                  </SecondaryRegularButton>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  )
}

export default AvailabilityDialog
